export default __webpack_public_path__ + "static/media/profile_main.488c57d1.png";